/**
 * Local view types for the /join profile flow. Mirrors the API shape from
 * @repository-module without importing it directly so that client bundles
 * stay tight.
 */

export interface ExperienceItem {
  id: string;
  company: string;
  companyDomain?: string | null;
  role: string | null;
  startedAt: string | null;
  endedAt: string | null;
  city?: string | null;
  country?: string | null;
  description?: string | null;
}

export interface EducationItem {
  id: string;
  school: string;
  degree: string | null;
  major: string | null;
  startedAt: string | null;
  endedAt: string | null;
  gpa?: string | null;
}

export interface LanguageItem {
  id: string;
  /** A `FILTER_CATALOG.LANGUAGE` slug (BCP 47), not a display name. */
  language: string;
  /** A `LANGUAGE_PROFICIENCY_LEVELS` slug, or null when unstated. */
  proficiency: string | null;
}

export interface SocialProfilesShape {
  github?: string | null;
  leetcode?: string | null;
  codechef?: string | null;
  codeforces?: string | null;
}

export interface ProfileDraft {
  fullName: string | null;
  headline: string | null;
  currentRole: string | null;
  currentCompany: string | null;
  location: string | null;
  photoUrl: string | null;
  linkedinUrl: string | null;
  summary: string | null;
  experiences: ExperienceItem[];
  educations: EducationItem[];
  skills: string[];
  certifications: string[];
  socialProfiles: SocialProfilesShape;
  portfolioUrl: string | null;
}

export const EMPTY_DRAFT: ProfileDraft = {
  fullName: null,
  headline: null,
  currentRole: null,
  currentCompany: null,
  location: null,
  photoUrl: null,
  linkedinUrl: null,
  summary: null,
  experiences: [],
  educations: [],
  skills: [],
  certifications: [],
  socialProfiles: {},
  portfolioUrl: null,
};
